import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

export const Container = styled(Box)`
    width: 100%;
    border-radius: ${({ theme }) => `${theme['border-radius-medium']}px`};
    background-color: ${({ theme }) => theme['surface-default']};
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px;
    margin-top: 8px;
`;
